import { render } from "./PurInvoiceSettingForm.vue?vue&type=template&id=46905a42"
import script from "./PurInvoiceSettingForm.vue?vue&type=script&lang=js"
export * from "./PurInvoiceSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__